const UserTypeEnum = {
  keyword: {
    PATIENT: 0,
    PROVIDER: 1,
    GLOBAL: 2
  },
  num: {
    0: 'PATIENT',
    1: 'PROVIDER',
    2: 'GLOBAL'
  }
}

export default UserTypeEnum